export class ThankYouPage {

  constructor() {
    this.yourState = document.querySelector('select[name="your-state"]');
    this.dataUrl = document.querySelector('#data-url');
  }
  init() {
    this.modalThankYou();

    if (!this.yourState || !this.dataUrl) {
      return;
    }

    this.yourState.addEventListener('change', (e) => {
      const currentState = e.target.value;
      let url;

      if (['pomorskie', 'kujawsko-pomorskie', 'warmińsko-mazurskie', 'łódzkie'].includes(currentState)) {
        url = document.querySelector('#url-dho').value;
      } else if (['śląskie', 'małopolskie', 'opolskie', 'świętokrzyskie', 'podkarpackie'].includes(currentState)) {
        url = document.querySelector('#url-sge').value;
      } else if (['lubelskie', 'podlaskie', 'mazowieckie'].includes(currentState)) {
        url = document.querySelector('#url-sko').value;
      } else if (['lubuskie', 'wielkopolskie', 'zachodniopomorskie', 'dolnośląskie'].includes(currentState)) {
        url = document.querySelector('#url-dkr').value;
      }

      this.dataUrl.setAttribute('data-url', url);

      document.querySelector('form.wpcf7-form').addEventListener('wpcf7mailsent', (event) => {
        const url = this.dataUrl.getAttribute('data-url');

        if (url) {
          window.open(url, '_blank').focus();
        }
      });
    });
  }

  modalThankYou() {
      const modalForm = document.querySelector('#modal-form');
      if (!modalForm) {
        return;
      }

      let state = modalForm.querySelector('select[name="your-state"]');
      let dataUrl = modalForm.querySelector('#data-modal-url');

    if (!state || !dataUrl) {
      return;
    }

    state.addEventListener('change', (e) => {
      const currentState = e.target.value;
      let url;

      if (['pomorskie', 'kujawsko-pomorskie', 'warmińsko-mazurskie', 'łódzkie'].includes(currentState)) {
        url = modalForm.querySelector('#url-modal-dho').value;
      } else if (['śląskie', 'małopolskie', 'opolskie', 'świętokrzyskie', 'podkarpackie'].includes(currentState)) {
        url = modalForm.querySelector('#url-modal-sge').value;
      } else if (['lubelskie', 'podlaskie', 'mazowieckie'].includes(currentState)) {
        url = modalForm.querySelector('#url-modal-sko').value;
      } else if (['lubuskie', 'wielkopolskie', 'zachodniopomorskie', 'dolnośląskie'].includes(currentState)) {
        url = modalForm.querySelector('#url-modal-dkr').value;
      }

      dataUrl.setAttribute('data-modal-url', url);

      document.querySelector('form.wpcf7-form').addEventListener('wpcf7mailsent', (event) => {
        const url = dataUrl.getAttribute('data-modal-url');

        if (url) {
          window.open(url, '_blank').focus();
        }
      });
    });
  }
}
